import { useTranslation } from "react-i18next";
import { Breadcrumbs } from "@unified-checkout/design-system";
import { useSettingsUtils } from "@app/dashboard/views/pages/inner_layout/Settings/useSettingsUtils";
import styles from "./header.module.scss";

export const Header = () => {
  const { t } = useTranslation();
  const { internalPagesBreadcrumbs } = useSettingsUtils();

  return (
    <div className={styles["header"]}>
      <div className={styles["header__breadcrumbs"]}>
        <Breadcrumbs
          linksProps={internalPagesBreadcrumbs.BUSINESS_PROFILE}
        />
      </div>

      <div className={styles["header__text-box"]}>
        <div className={styles["header__text-box__title"]}>
          {t('innerLayout.businessProfilePage.title')}
        </div>
        <div className={styles["header__text-box__hint"]}>
          {t('innerLayout.businessProfilePage.hint')}
        </div>
      </div>
    </div>
  );
};
